<template>
  <div class="table_wrap">
<!--    <span class="total_length">총 {{ paginationData.total }}개 </span>-->
    <el-table :data="boardData"
              class="list-table"
              header-cell-class-name="list-header"
              empty-text="데이터가 없습니다."
              height="695"
    >
      <el-table-column
          class="table_no"
          type="index"
          label="No"
          width="90"
          class-name="num text-center"
          :index="tableIdx"
      >
      </el-table-column>
      <el-table-column width="200" label="언어" class-name="text-center">
        <template slot-scope="scope">
                    <span>
<!--                        {{ returnLang(scope.row.Language.c_idx) }}-->
                       {{ scope.row.Language.c_lang_ko }}
                    </span>
        </template>
      </el-table-column>
      <el-table-column min-width="50" label="말머리" prop="wr_headtext" class-name="text-center"></el-table-column>
      <el-table-column min-width="155" label="제목" prop="wr_subject" class-name="text-center"></el-table-column>
      <el-table-column label="작성일자" width="150" class-name="text-center">
        <template slot-scope="scope">
                    <span>
                        {{ scope.row.created_at }}
                    </span>
        </template>
      </el-table-column>
      <el-table-column label="옵션" width="150" class-name="text-center">
        <template slot-scope="scope">
          <div class="row-info">
            <el-button class="com_btn" @click="goDetail(scope.row.wr_id)">
              상세
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

  </div>
</template>

<script>
import util from "@/mixins/util";
import dateMixins from "@/mixins/dateMixins";
import alertMixins from "@/mixins/alertMixins";

export default {
  name: "BoardListDefaultLayout",
  mixins: [dateMixins, alertMixins],
  components: {},
  inject: {
    setPage: {
      default: () => {
      }
    },
    boardListSetData: {
      default: () => {
      }
    },
    setFilter: {
      default: () => {
      }
    },
    changeSeqData: {}
  },
  provide() {
    return {}
  },
  props: {
    boardType: '',
    boardData: {
      default: () => {
        return []
      }
    },
    paginationData: {
      default: () => {
        return {total: 0, page: 0, size: 0,}
      }
    },
  },
  data() {
    return {}
  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    returnDate(date = null) {
      if (!date) {
        return '';
      }
      return this.$moment(date).format('YYYY-MM-DD HH:mm')
    },
    goDetail(key) {
      this.$router.push(`/notice/${key}`);
    },
    tableIdx(index) {
      return this.paginationData.total - index - (this.paginationData.page - 1) * this.paginationData.size;
    },
    returnLang(lang){
      switch (lang) {
        case 1:
          return '한국어';
        case 30:
          return '영어';
        default:
          return '-';
      }
    }
    // checkNum(row) {
    //   let num = Number(row.wr_seq);
    //   if(row.wr_seq === '' || !Number.isInteger(num)) {
    //     this.errorAlert('순서를 입력해주세요.')
    //     return false;
    //   }
    //   this.changeSeqData(row);
    // },
  },
  watch: {},
}
</script>

<style scoped>

</style>
